import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as validationService from "../add-device-modal/validationService";
import { debug } from "../../utils";

function PowerCLIUsernameField({ value, onChange, centralCredentialId, error, disabled }) {

    const [disableInput, setDisableValue] = useState(disabled)

    const ProcessData = async () => {
        if (centralCredentialId && centralCredentialId > 0) {
            validationService.cleanValidation('powerCliUsername');
            setDisableValue(true);
            onChange('');
        } 
        else {
            validationService.validateUsername(value, 'powerCliUsername');
            setDisableValue(false);
        }       
        return () => validationService.cleanValidation('powerCliUsername');
    }
    useEffect(() => {
        ProcessData();
        /* eslint-disable react-hooks/exhaustive-deps */

    }, [value, centralCredentialId])

    // useEffect(() => {
    //     validationService.validateUsername(value, 'powerCliUsername');
    //     return () => validationService.cleanValidation('powerCliUsername');
    // }, [value])

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="powercli_username">Username <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="powercli_username-key"
                    value={centralCredentialId ? '' : value}
                    disabled={disableInput}
                    onChange={disableInput ? null : event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("PowerCLIUsernameField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.powerCliUsername,
    }
}

export default connect(mapStateToProps)(PowerCLIUsernameField);
